// extracted by mini-css-extract-plugin
export default {"bagIconButton":"KNZuF","numberOfItems":"ekyli"};